import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { FormService } from '../../core/services/form.service';

@Component({
  selector: 'app-invite-follow-up-modal',
  templateUrl: './invite-follow-up-modal.component.html',
  styleUrls: ['./invite-follow-up-modal.component.css']
})
export class InviteFollowUpModalComponent {

  followUpDetails: any;
  name: any;

  @ViewChild('followUpDetailsModal')
  public followUpDetailsModal: ModalDirective;

  constructor(private formService: FormService) { }

  // show modal
  show(id, name) {
    this.formService.getFollowUpDetails(id).subscribe(
      response => {
        this.followUpDetails = response;
        this.followUpDetailsModal.show();
      }
    );
    this.name = name;
  }

  // hide modal
  hide() {
    this.followUpDetailsModal.hide();
  }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/invite-follow-up-modal/invite-follow-up-modal.component.ts